import type { TriggerAutomaticSettingsRunParams } from 'api/automaticSettingRuns/automaticSettingRuns.types'
import Datetime from 'utils/datetime/datetime'

type DayRange = { firstDay: ISODateTime; lastDay: ISODateTime }
type RunWindow = Pick<TriggerAutomaticSettingsRunParams, 'start_time' | 'end_time'>

// The backend caps a window at three calendar months, and 89 days is the shortest three months.
const MAX_RUN_WINDOW_DAYS = 89

function localMidnight(time: ISODateTime | Date, dayOffset = 0): Date {
  const date = new Date(time)
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + dayOffset)
}

/** The Monday-to-Sunday week before the one `now` falls in, as the local midnight of each end day. */
export function previousWeek(now: Date): DayRange {
  const daysSinceMonday = (now.getDay() + 6) % 7
  return {
    firstDay: Datetime.toISOString(localMidnight(now, -daysSinceMonday - 7)),
    lastDay: Datetime.toISOString(localMidnight(now, -daysSinceMonday - 1)),
  }
}

/** The run window covering the whole local days `firstDay` through `lastDay`; `end_time` is exclusive. */
export function runWindowOfDays(firstDay: ISODateTime, lastDay: ISODateTime): RunWindow {
  return {
    start_time: Datetime.toISOString(localMidnight(firstDay)),
    end_time: Datetime.toISOString(localMidnight(lastDay, 1)),
  }
}

export function isRunWindowEmpty({ start_time, end_time }: RunWindow): boolean {
  return !Datetime.isBefore(start_time, end_time)
}

export function isRunWindowTooLong({ start_time, end_time }: RunWindow): boolean {
  return Datetime.isAfter(end_time, Datetime.toISOString(localMidnight(start_time, MAX_RUN_WINDOW_DAYS)))
}

export { MAX_RUN_WINDOW_DAYS }
